import React from 'react';
import { useDynamicForm } from './hooks/useDynamicForm';
import { ApiField } from './components/ApiField';
// import { DynamicFormWrapperAFY } from './components/DynamicFormWrapperAFY';

interface DynamicFormProps {
  formStructure: {
    title: string;
    description: string;
    diagram: Array<{
      [key: string]: Array<{
        order: string;
        uniqueId: string;
        typeComponent: string;
        active: boolean;
        properties: Record<string, any>;
        screenSpace?: string;
        api?: {
          method: 'GET' | 'POST' | 'PUT' | 'DELETE';
          url: string;
        };
        validations?: Array<Record<string, any>>;
      }>;
    }>;
  };
  onSubmit?: (formData: any) => void;
}

export default function DynamicForm() {
  
  
  return (
    <div>
      {/* <h1>Dynamic Form</h1> */}
      {/* <DynamicFormWrapperAFY formStructure={formStructure} /> */}
    </div>
  );
}